import { Document } from '@contentful/rich-text-types';
import { INbnServiceTileContent, INTERNET_SERVICE_STATUS } from '@belong/types';
import { Entry } from 'contentful';
import { FLink, IEntryLink } from '../elements';
import { FOrganismServiceLinks, IEntryOrganismServiceLinks } from '../organisms/organismServiceLinks.factory';
import { parseFlexibleContent } from '../parseFlexibleContent';
import { FRichText } from '../richText.factory';
import { FMoleculeAlert, IEntryMoleculeAlert } from './moleculeAlert.factory';
import { FMoleculeInformationPanel, IEntryMoleculeInformationPanel } from './moleculeInformationPanel.factory';
import { FMoleculeTileHeader, IEntryTileHeader } from './moleculeTileHeader.factory';

export interface IEntryNbnServiceTileContent {
  key: INTERNET_SERVICE_STATUS;
  bodyContent?: Document;
  tileHeader: Entry<IEntryTileHeader>;
  alerts?: Entry<IEntryMoleculeAlert>[];
  primaryAction?: Entry<IEntryLink>;
  secondaryAction?: Entry<IEntryLink>;
  updatesSection?: Entry<IEntryMoleculeInformationPanel>[];
  quickLinksList?: Entry<IEntryOrganismServiceLinks>;
}

const contentFactoryMap = new Map([
  ['moleculeAlert', { factory: FMoleculeAlert }],
  ['moleculeInformationPanel', { factory: FMoleculeInformationPanel }]
]);

export const FMoleculeNbnServiceTileContent = (data: Entry<IEntryNbnServiceTileContent>): INbnServiceTileContent => {
  const { fields, metadata } = data;
  const { alerts, bodyContent, key, tileHeader, primaryAction, secondaryAction, updatesSection, quickLinksList } =
    fields;

  return {
    key,
    tags: metadata.tags.map(tag => tag?.sys?.id),
    bodyContent: bodyContent && FRichText(bodyContent),
    tileHeader: FMoleculeTileHeader(tileHeader),
    primaryAction: primaryAction && FLink(primaryAction),
    secondaryAction: secondaryAction && FLink(secondaryAction),
    alerts: alerts && parseFlexibleContent(alerts, contentFactoryMap),
    updatesSection: updatesSection && parseFlexibleContent(updatesSection, contentFactoryMap),
    quickLinksList: quickLinksList && FOrganismServiceLinks(quickLinksList)
  };
};
